export default "__VITE_ASSET__f0b17ed0__"